import axios from 'axios'
import mixin, { treeRecursionMap } from '../mixins'

import localForage from 'localforage'

const labelValue = mixin.props.labelValue.default()

// 检测本地缓存是否需要刷新
export async function checkCacheRefresh () {
    const { data } = await axios.get(`/api/cascadingDictionarys/get-flush-cascading-dictionary-time`)
        .catch(error => { console.error(`获取刷新时间异常`, error.response) })
    const localUpdateTime = await getCache(`J_CASCADER_UpdateTime`)
    const updateTime = data.data
    if (localUpdateTime != updateTime) {
        // 清空缓存
        removeCache(`J_CASCADER_TREE`)
        removeCache(`J_CASCADER_MAP`)
        setCache(`J_CASCADER_UpdateTime`, updateTime)
    } else {
        // 读取本地缓存到内存中
        getLocalCache()
    }
}

function getLocalCache () {
    getCache(`J_CASCADER_MAP`).then(map => state.Map = (map || {}))

    getCache(`J_CASCADER_TREE`).then(tree => state.Tree = (tree || {}))
}

function url (key) { // 默认url指定
    return `/api/cascadingDictionarys/${key}/getByKey`
}

// const defaultStorage = sessionStorage
// const defaultStorage = localStorage
const defaultStorage = localForage

const getCache = async (key) => {
    const constructorName = defaultStorage.constructor.name
    if (constructorName === 'Storage') return JSON.parse(defaultStorage.getItem(key))
    return await defaultStorage.getItem(key)
}

const setCache = async (key, value) => {
    const constructorName = defaultStorage.constructor.name
    if (constructorName === 'Storage') return defaultStorage.setItem(key, JSON.stringify(value))
    return await defaultStorage.setItem(key, value)
}

const removeCache = async (key) => {
    return defaultStorage.removeItem(key)
}

const state = {
    Map: {},
    Tree: {}
}

const mutations = {
    Map (state, { key, map }) {
        state.Map[key] = map
    },
    Tree (state, { key, tree }) {
        state.Tree[key] = tree
    }
}

const actions = {
    async getCascaderTreeByKey (content, key) {
        let map = content.state.Map[key]
        let tree = content.state.Tree[key]
        if (tree && map) {
            return { tree, map }
        } else {
            content.commit('Tree', { key, tree: [] })
            content.commit('Map', { key, map: {} })
        }
        const { data } = await axios.get(url(key)).catch(error => { console.error(`${url(key)}接口，级联数据获取异常`,error.response) })
        if (data.status != 'yes') return console.error(`${url(key)}接口，级联数据获取异常`)
        map = {}
        tree = data.data.dictionaryJson
        if (tree && tree.length > 0) { //
            treeRecursionMap(tree, map, labelValue)
            state.Tree[key].length = 0
            state.Tree[key].push(...tree)
            Object.assign(state.Map[key], map)
            setCache(`J_CASCADER_TREE`, content.state.Tree)
            setCache(`J_CASCADER_MAP`, content.state.Map)
        }

        return { tree, map }
    }
}

checkCacheRefresh()

// 模块方式注册
export const JCascader = {
    namespaced: true,
    state,
    mutations,
    actions
}
